export enum APIKeyType {
    Mobile,
    Consumer
}